import { useState, useEffect } from 'react';
import LoadingScreen from './LoadingScreen';
import GameBtfd from '../assets/game-btfd.png';
import GameCandyDefence from '../assets/game-candydefence.png';
// import GameChooChoo from '../assets/game-choochoo.png';
import GameEVM from '../assets/game-evm.png';
// import GameKittySlash from '../assets/game-kittyslash.png';
import GamePepeKingdom from '../assets/game-pepekingdom.png';
import GameSugarRush from '../assets/game-sugarrush.png';
import GameZookQuest from '../assets/game-zookquest.webp';
import GameHatchLand from '../assets/game-hatchland.webp';
import GameKA from '../assets/game-ka.png';
import GameWizverse from '../assets/game-wizverse.jpg';
import DappBridge from '../assets/dapp-bridge.webp';
import DappSyncSwap from '../assets/dapp-syncswap.webp';

const Ecosystem = () => {
  const [games, setGames] = useState([]);
  const [dapps, setDapps] = useState([]);
  const [loading, setLoading] = useState(true);

  const ecosystemData = {
    games: [
      // {
      //   id: 1,
      //   image: GameChooChoo,
      //   name: 'Choo Choo Spirit',
      //   link: 'https://choochoospirits.io/',
      // },
      {
        id: 2,
        image: GameBtfd,
        name: 'BTFD',
        link: 'https://btfd.agency/',
      },
      {
        id: 3,
        image: GameEVM,
        name: 'EVM',
        link: 'https://evmwarfare.xyz/',
      },
      {
        id: 4,
        image: GameSugarRush,
        name: 'Sugar Rush',
        link: 'https://sugarrush.zkcandy.io/',
      },
      {
        id: 5,
        image: GamePepeKingdom,
        name: 'Pepe Kingdom',
        link: 'https://app.pepekingdom.wtf/',
      },
      {
        id: 6,
        image: GameCandyDefence,
        name: 'Candy Defence',
        link: 'https://app.candydefense.xyz/',
      },
      // {
      //   id: 7,
      //   image: GameKittySlash,
      //   name: 'Kitty Slash',
      //   link: 'https://app.kittyslash.com/',
      // },
      {
        id: 8,
        image: GameZookQuest,
        name: 'Zook Quest',
        link: 'https://t.me/zooksquestbot',
      },
      {
        id: 9,
        image: GameHatchLand,
        name: 'Hatch Land',
        link: 'https://www.outofthenest.io/hatching',
      },
      {
        id: 10,
        image: GameKA,
        name: 'Killers Arena',
        link: 'https://killersarena.fun/',
      },
      {
        id: 11,
        image: GameWizverse,
        name: 'Wizverse',
        link: 'https://zkcandy.wizverse.net/',
      },
    ],
    dapps: [
      {
        id: 1,
        name: "Bridge",
        image: DappBridge,
        link: "https://bridge.zkcandy.io/"
      },
      {
        id: 2,
        name: "SyncSwap",
        image: DappSyncSwap,
        link: "https://syncswap.xyz/"
      },
    ]
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Simulate API latency  
        // await new Promise(resolve => setTimeout(resolve, 1000));

        // Simulate API call  
        setGames(ecosystemData.games);
        setDapps(ecosystemData.dapps);

      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div id="ecosystem" className="p-4">
      {/* <h1 className="text-2xl font-bold mb-6 page-title">ZKcandy Ecosystem</h1>   */}

      <section className="mb-4">
        <h2 className="section-title leading-none">Games</h2>
        <div className="games grid grid-cols-3 gap-4 border-2 rounded-[1rem] p-4 bg-[#9747ff61]">
          {games.map((game) => (
            <a
              target='_blank'
              href={game.link}
              key={game.id}
              className="shadow-[5px_5px_0_rgb(255,0,194)] bg-opacity-20 backdrop-blur-sm rounded-xl border-2 overflow-hidden shadow"
            >
              <img
                src={game.image}
                alt={game.name}
                className="w-full rounded-t-lg"
              />
              {/* <div className="w-full backdrop-blur border-t-2  border-dashedd">
                <h3 className="font-semibold text-center">{game.name}</h3>
                <p className="text-sm text-gray-600">{game.description}</p>
                <button className="bg-[#6f00ff] text-sm text-white py-2 rounded-b-lg w-full uppercase font-bold">
                  Play Now
                </button>
              </div> */}
            </a>
          ))}
        </div>
      </section>

      <section>
        <h2 className="section-title">Dapps</h2>
        <div className="grid grid-cols-2 gap-4 border-2 rounded-[1rem] p-5 bg-[#9747ff61]">
          {dapps.map((dapp) => (
            <a
              key={dapp.id}
              href={dapp.link}
              target='_blank'
              className="shadow-[5px_5px_0_#6f00ff] bg-[#6f00ff] backdrop-blur-sm rounded-xl border-2 overflow-hidden shadow"
            >
              <img
                src={dapp.image}
                alt={dapp.name}
                className="w-full h-32 object-cover"
              />
              {/* <p className="text-sm">{dapp.description}</p> */}
              <button className="bg-[#ff00c2] text-white text-center py-2 rounded-b-lg w-full whitespace-nowrap">
                {dapp.name}
              </button>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Ecosystem;  
